const CARD_CONTEXTS = [
  "GanandoLocal",
  "EmpatandoLocal",
  "PerdiendoLocal",
  "GanandoVisitante",
  "EmpatandoVisitante",
  "PerdiendoVisitante",
];

export const DISCIPLINARY_WEIGHTS = {
  yellow: 1,
  secondYellow: 2,
  red: 5,
};

const sumCardType = (player, prefix) => CARD_CONTEXTS.reduce(
  (total, context) => total + (Number(player?.tarjetas?.[`${prefix}${context}`]) || 0),
  0,
);

export const getPlayerDisciplinarySummary = (player) => {
  const recordedYellow = sumCardType(player, "tarjetasAmarillas");
  const secondYellow = sumCardType(player, "segundasAmarillas");
  const red = sumCardType(player, "tarjetasRojas");
  const yellow = Math.max(recordedYellow, secondYellow);

  return {
    yellow,
    secondYellow,
    red,
    points:
      yellow * DISCIPLINARY_WEIGHTS.yellow
      + secondYellow * DISCIPLINARY_WEIGHTS.secondYellow
      + red * DISCIPLINARY_WEIGHTS.red,
  };
};
